var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'--scale-rate': _vm.scaleRate()}),attrs:{"id":"app"}},[_c('router-view'),(!_vm.isVerticalScreen())?_c('floating-window',{staticClass:"fade-in",class:{'active': _vm.showFloating}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }